"use client";
import React from "react";
import CarouselSection from "../ui/carousel-section";
import BrandCard from "./brand-card";
import { BrandModel } from "@/types/brand";

const BrandsCarousel = ({
  brands,
  title,
  subTitle,
  icon,
}: {
  brands: BrandModel[];
  title: string;
  subTitle?: string;
  icon?: React.ReactNode;
}) => {
  return (
    <CarouselSection
      title={title}
      items={brands}
      renderItem={(brand) => <BrandCard brand={brand} />}
      breakpoints={{
        xl: "xl:basis-1/10",
        lg: "lg:basis-1/8",
        md: "md:basis-1/6",
        sm: "sm:basis-1/4",
        base: "basis-1/3",
      }}
      subTitle={subTitle}
      icon={icon}
    />
  );
};

export default BrandsCarousel;
